/* =============================================
   LE FUMOIR — SEARCH JS
   Header overlay + predictive dropdown
   ============================================= */

document.addEventListener('DOMContentLoaded', function () {

  var searchBtn      = document.getElementById('header-search-btn');
  var searchOverlay  = document.getElementById('header-search-overlay');
  var searchInput    = document.getElementById('header-search-input');
  var searchDropdown = document.getElementById('header-search-dropdown');
  var closeBtn       = document.getElementById('header-search-close');

  if (!searchBtn || !searchOverlay || !searchInput) return;

  /* ---------- open / close ---------- */

  function openSearch() {
    searchOverlay.classList.add('search-overlay--open');
    searchBtn.setAttribute('aria-expanded', 'true');
    setTimeout(function () { searchInput.focus(); }, 50);
  }

  function closeSearch() {
    searchOverlay.classList.remove('search-overlay--open');
    searchBtn.setAttribute('aria-expanded', 'false');
    searchDropdown.innerHTML = '';
    searchDropdown.classList.remove('search-dropdown--visible');
    searchInput.value = '';
  }

  searchBtn.addEventListener('click', openSearch);
  if (closeBtn) closeBtn.addEventListener('click', closeSearch);

  /* Close on outside click (clicking the dim area) */
  searchOverlay.addEventListener('click', function (e) {
    if (e.target === searchOverlay) closeSearch();
  });

  /* Close on Escape */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && searchOverlay.classList.contains('search-overlay--open')) {
      closeSearch();
    }
  });

  /* ---------- predictive search ---------- */

  var debounceTimer;

  searchInput.addEventListener('input', function () {
    var q = this.value.trim();
    clearTimeout(debounceTimer);

    if (q.length < 2) {
      searchDropdown.innerHTML = '';
      searchDropdown.classList.remove('search-dropdown--visible');
      return;
    }

    debounceTimer = setTimeout(function () { fetchPredictive(q); }, 300);
  });

  function fetchPredictive(q) {
    var url = '/search/suggest.json'
      + '?q=' + encodeURIComponent(q)
      + '&resources[type]=product,page,article'
      + '&resources[limit]=5'
      + '&resources[options][unavailable_products]=last';

    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var res = (data.resources && data.resources.results) || {};
        renderDropdown(q, res.products || [], res.pages || [], res.articles || []);
      })
      .catch(function () {});
  }

  /* /search/suggest.json returns price as a major-unit string (e.g. "46.00") */
  function formatMoney(val) {
    if (val === null || val === undefined || val === '') return '';
    var n = parseFloat(val);
    if (isNaN(n)) return '';
    return 'AED ' + n.toFixed(2).replace(/\.00$/, '');
  }

  function escHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function renderDropdown(q, products, pages, articles) {
    var html = '';

    /* Products */
    if (products.length) {
      html += '<div class="search-dropdown__group">'
        + '<span class="search-dropdown__label">Products</span>';

      products.forEach(function (p) {
        var thumb = p.featured_image
          ? '<img src="' + escHtml(p.featured_image.url) + '" alt="" loading="lazy" width="48" height="48">'
          : '<span class="search-dropdown__thumb-placeholder"></span>';
        var price = formatMoney(p.price);

        html += '<a href="' + escHtml(p.url) + '" class="search-dropdown__product">'
          + '<span class="search-dropdown__thumb">' + thumb + '</span>'
          + '<span class="search-dropdown__info">'
          + '<span class="search-dropdown__product-title">' + escHtml(p.title) + '</span>'
          + (price ? '<span class="search-dropdown__price">' + price + '</span>' : '')
          + '</span>'
          + '</a>';
      });

      html += '</div>';
    }

    /* Pages + Articles */
    var editorial = pages.concat(articles);
    if (editorial.length) {
      html += '<div class="search-dropdown__group">'
        + '<span class="search-dropdown__label">Pages &amp; Recipes</span>';

      editorial.forEach(function (item) {
        html += '<a href="' + escHtml(item.url) + '" class="search-dropdown__item">'
          + escHtml(item.title)
          + '</a>';
      });

      html += '</div>';
    }

    /* Empty state */
    if (!products.length && !editorial.length) {
      html = '<div class="search-dropdown__empty">No results for &ldquo;' + escHtml(q) + '&rdquo;</div>';
    } else {
      html += '<a href="/search?q=' + encodeURIComponent(q) + '" class="search-dropdown__all">'
        + 'View all results &rarr;'
        + '</a>';
    }

    searchDropdown.innerHTML = html;
    searchDropdown.classList.add('search-dropdown--visible');
  }

  /* Clicking a result closes the overlay */
  searchDropdown.addEventListener('click', function (e) {
    if (e.target.closest('a')) closeSearch();
  });
});
